<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group">
    <div class="form-group col-md-5" style="display: flex;justify-content: start;align-items: center;">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-12 col-md-3">
      <div [formGroup]="formularioFiltroTipoDeVendedores" novalidate class="form-group">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedoresFiltro" [label]="'Tipo de Vendedor *'" formControlName="idTipoVendedor"
          [control]="formularioFiltroTipoDeVendedores.get('idTipoVendedor')" [id]="'idTipoVendedor'">
        </app-lfsa-combo-box>
      </div>
    </div>
    <div class="form-group col-md-2" style="display: flex;justify-content: start;align-items: center;">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div>
    <div class="form-group col-md-2" style="display: flex;justify-content: start;align-items: center;">
      <a href="comisiones/asignacion-y-distribucion-incentivos-csv" style="width: 100%;">
        <button class={{DAT_BTNCSS.success}}>Cargar</button>
      </a>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>


<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
<ng-template #enviarTemplateResport>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese ID'"
          [label]="'ID *'" [id]="'asignacionId'" formControlName="asignacionId"
          [control]="formulario.get('asignacionId')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'date'" [class]="'letrasDanger'" [placeholder]="'Ingrese Fecha Inicio'"
          [label]="'Fecha Inicio *'" [id]="'fechaInicio'" formControlName="fechaInicio"
          [control]="formulario.get('fechaInicio')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'date'" [class]="'letrasDanger'" [placeholder]="'Ingrese Fecha Fin'"
          [label]="'Fecha Fin *'" [id]="'fechaFin'" formControlName="fechaFin"
          [control]="formulario.get('fechaFin')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <label>Tipo de Vendedor *</label>
        <select class="form-control" formControlName="tipoVendedorId" id="tipoVendedorId" (change)="changeTipoVendedor();">
          <option *ngFor="let data of listTiposDeVendedores" [value]="data.idTipo">{{ data.descripcion }}</option>
        </select>
        <!-- <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores" formControlName="tipoVendedorId"
          [control]="formulario.get('tipoVendedorId')" [label]="'Tipo de Vendedor *'" [id]="'tipoVendedorId'">
        </app-lfsa-combo-box> -->
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'nombreAMostrar'" [idOpcion]="'idVendedor'"
          [comboBox]="listVendedores" formControlName="vendedorId"
          [control]="formulario.get('vendedorId')" [label]="'Seleccione Vendedor *'" [id]="'vendedorId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Sueldo variable'"
          [label]="'Sueldo variable *'" [id]="'sueldoVariable'" formControlName="sueldoVariable"
          [control]="formulario.get('sueldoVariable')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Usuario de Carga'"
          [label]="'Usuario de Carga *'" [id]="'usuarioCarga'" formControlName="usuarioCarga"
          [control]="formulario.get('usuarioCarga')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Fecha de Carga'"
          [label]="'Fecha de Carga *'" [id]="'fechaCarga'" formControlName="fechaCarga"
          [control]="formulario.get('fechaCarga')"></app-lfsa-input>
      </div>
    </div>
    <hr>
    Detalle de Asignación de Incentivo
    <div class="row">
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idVariable'"
          [comboBox]="listTiposDeVariables" formControlName="variableId"
          [control]="formulario.get('variableId')" [label]="'Variable de Compensación *'" [id]="'variableId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese % Cumplimiento'"
          [label]="'% Cumplimiento (sobre variables fijas)*'" [id]="'cumplimiento'" formControlName="cumplimiento"
          [control]="formulario.get('cumplimiento')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese % Ganancia'"
          [label]="'% Peso / Ganancia *'" [id]="'ganancia'" formControlName="ganancia"
          [control]="formulario.get('ganancia')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese % en Dolares'"
          [label]="'% en Dolares *'" [id]="'dolares'" formControlName="dolares"
          [control]="formulario.get('dolares')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4" style="display:flex;align-items: center;" *ngIf="formulario.get('dolares').value > 0">
        Por el cumplimineto del {{ formulario.get('cumplimiento').value }}%, gana incentivo del {{ formulario.get('ganancia').value }}%.
      </div>
    </div>
  </div>

  <div class="row">
    <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </div>
</ng-template>
